import React, { Component } from "react";
import { Route } from "react-router-dom";
import SignIn from "./features/consent/signIn";
import SelectMemberContainer from "./features/consent/selectMemberContainer";
import AccessNotSupported from "./features/consent/accessNotSupported";
import UserConsent from "./features/consent/userConsent";
import SelectProviderContainer from "./features/payer/selectProviderContainer";
import SelectTransferMemberContainer from "./features/payer/selectTransferMemberContainer";
import P2pCallback from "./features/payer/p2pCallback";
import ExternalPayerRedirect from "./features/payer/externalPayerRedirect";
import AccessDenied from "./features/payer/accessDenied";

class App extends Component {
  render() {
    return (
      <div>
        <Route exact path="/hi2-auth-ui" status={200} />
        <Route exact path="/hi2-auth-ui/sign-in" component={SignIn} />
        <Route
          exact
          path="/hi2-auth-ui/access-not-supported"
          component={AccessNotSupported}
        />
        <Route
          exact
          path="/hi2-auth-ui/select-member"
          component={SelectMemberContainer}
        />
        <Route exact path="/hi2-auth-ui/user-consent" component={UserConsent} />
        <Route
          exact
          path="/hi2-auth-ui/select-provider"
          component={SelectProviderContainer}
        />
        <Route
          exact
          path="/hi2-auth-ui/select-transfer"
          component={SelectTransferMemberContainer}
        />
        <Route exact path="/hi2-auth-ui/p2p-callback" component={P2pCallback} />
        <Route
          exact
          path="/hi2-auth-ui/external-payer-redirect"
          component={ExternalPayerRedirect}
        />
        <Route
          exact
          path="/hi2-auth-ui/access-denied"
          component={AccessDenied}
        />
      </div>
    );
  }
}

export default App;
